import DocumentComplianceReview from './DocumentComplianceReview.vue'

const REVIEW_RENDERERS = Object.freeze({
    'document-compliance': DocumentComplianceReview,
})

const resolveReviewRenderer = name => REVIEW_RENDERERS[name] || null

export { resolveReviewRenderer }
